import styles from "./styles.module.scss";
import CreatePinWidget from "./widget";

export {styles};
export default CreatePinWidget;